export default function (ngModule) {
    ngModule.factory('ArbitrarySplit', function ($translate, BaseClass, Currencies) {

        /**
         * Constructor function
         *
         * @param {Object} attributes Initial attributes for the model
         */
        function ArbitrarySplit(attributes) {
            _.assign(this, attributes);
        }

        ArbitrarySplit.modelName = 'ArbitrarySplit';

        BaseClass.apply(ArbitrarySplit);

        ArbitrarySplit.validates({
            whitelabel_id: {
                required: true
            },
            name: {
                required: true
            },
            code: {
                required: true
            }
        });

        ArbitrarySplit.configureApi('/split/arbitrary/:guid', {queryAdmin: '/split/arbitrary/company/:company'});

        ArbitrarySplit.prototype.toString = function () {
            return this.name;
        };

        return ArbitrarySplit;
    });
}
